import React, { useEffect, useState } from "react";
import Header from "./components/common/Header";
import Message from "./components/Message";
import Navbar from "./components/Navbar";
import Upload from "./components/Upload";
import { Box, Backdrop, CircularProgress } from "@mui/material";
import { SnackbarProvider } from "notistack";
import SendWhatsapp from "./components/SendWhatsapp";
import Profile from "./components/common/Profile";
import TemplatesType1 from "./components/TemplatesType1";
import PersonalWhatsapp from "./components/PersonalWhatsapp";
import MessageQueue from "./components/personalWAComponent/MessageQueue";
import GroupAdd from "./components/personalWAComponent/GroupAdd";
import Login from "./components/Login";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { BrowserRouter } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import EmailQueue from "./components/Email/EmailQueue";
import EmailSchedule from "./components/Email/EmailSchedule";
import EmailAnalytics from "./components/Email/EmailAnalytics";
import PostEmailView from "./components/Email/PostEmailView";

// comment this
import AppContent from "./AppContent";
import { ConfirmationDialogProvider } from "./context/ConfirmationDialogProvider";

const GOOGLE_CLIENT_ID =
    process.env.REACT_APP_GOOGLE_CLIENT_ID ||
    "543706434557-nvmmkvk1difngtahho1kbvssenduppcl.apps.googleusercontent.com";

const App = () => {
    return (
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
            <AuthProvider>
                <ConfirmationDialogProvider>
                    <BrowserRouter>
                        <AppContent />
                    </BrowserRouter>
                </ConfirmationDialogProvider>
            </AuthProvider>
        </GoogleOAuthProvider>
    );
};
export default App;
